"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SHOPPING_BAG_COUNTER_ROOT = exports.MINIBAG_COUNTER_ANIMATION_TIMEOUT = void 0;
const SHOPPING_BAG_COUNTER_ROOT = exports.SHOPPING_BAG_COUNTER_ROOT = 'shopping-bag-counter-root';
const MINIBAG_COUNTER_ANIMATION_TIMEOUT = exports.MINIBAG_COUNTER_ANIMATION_TIMEOUT = 1000;